module.exports = __webpack_public_path__ + "static/icons/banner_rentas_2.a47c49f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-home/banners/banner_rentas_2.svg
// module id = /WEU
// module chunks = 1